
import React from 'react';

interface IProps {
  style?: any;
  
}

export const TriangleIcon:React.FC<IProps> = (props: IProps) => {
  return (
<svg width="85" height="75" viewBox="0 0 85 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M42.5 0L84.5022 74.25H0.497768L42.5 0Z" fill="#dee2eb"/>
</svg>

    
  )
}
